import { render, staticRenderFns } from "./SetResponsibleModal.vue?vue&type=template&id=55810ae6&scoped=true"
import script from "./SetResponsibleModal.vue?vue&type=script&lang=js"
export * from "./SetResponsibleModal.vue?vue&type=script&lang=js"
import style0 from "./SetResponsibleModal.vue?vue&type=style&index=0&id=55810ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55810ae6",
  null
  
)

export default component.exports